import Storage from "@/services/Storage"

export default new class Token extends Storage {
    constructor() {
        super("auth_token")
    }
}
